module.exports = __webpack_public_path__ + "img/QA.43728edd.svg";